var UserNotificationsApiService_1;
import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { zip } from 'rxjs';
import { ConstructorName } from '../../../decorators';
import * as i0 from "@angular/core";
import * as i1 from "../../monitoring.service";
import * as i2 from "../../api.service";
let UserNotificationsApiService = class UserNotificationsApiService {
  static {
    UserNotificationsApiService_1 = this;
  }
  monitoringService;
  api;
  url = 'notification-service/v1/notifications';
  apiVersion;
  constructor(monitoringService, api) {
    this.monitoringService = monitoringService;
    this.api = api;
    this.monitoringService.sendTrackEvent(Reflect.getMetadata('constructorName', UserNotificationsApiService_1), 'constructor');
    this.setUrl(this.url);
  }
  getList() {
    return this.api.get(this.url, {}, this.apiVersion);
  }
  sendNotifications(notification) {
    return this.api.post(this.url, notification, {}, this.apiVersion);
  }
  markAsDeleted(id) {
    return this.api.patch(`${this.url}/${id}/mark-as-deleted`, null, {}, this.apiVersion);
  }
  markAsRead(id) {
    return this.api.patch(`${this.url}/${id}/mark-as-read`, null, {}, this.apiVersion);
  }
  markAllAsDeleted(ids) {
    return zip(ids.map(id => this.markAsDeleted(id)));
  }
  markAllAsRead(ids) {
    return zip(ids.map(id => this.markAsRead(id)));
  }
  setUrl(url) {
    this.url = url ?? this.url;
    return this;
  }
  setApiVersion(apiVersion) {
    this.apiVersion = apiVersion ?? this.apiVersion;
    return this;
  }
  static ɵfac = function UserNotificationsApiService_Factory(t) {
    return new (t || UserNotificationsApiService)(i0.ɵɵinject(i1.MonitoringService), i0.ɵɵinject(i2.ApiService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserNotificationsApiService,
    factory: UserNotificationsApiService.ɵfac,
    providedIn: 'root'
  });
};
UserNotificationsApiService = UserNotificationsApiService_1 = __decorate([ConstructorName('UserNotificationsApiService')], UserNotificationsApiService);
export { UserNotificationsApiService };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserNotificationsApiService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.MonitoringService
  }, {
    type: i2.ApiService
  }], null);
})();
